import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPageTitle } from "../../../app/features/DataSlice";
import HeliorOneList from "../../../components/HeliorOne/HeliorOneList";

const HeOne = () => {
  const pageTitle = "X-ONE";
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(pageTitle));
  });

  return (
    <div className="my-3">
      <HeliorOneList pageTitle={pageTitle} />
    </div>
  );
};

export default HeOne;
